import { render, staticRenderFns } from "./NavSidebar.vue?vue&type=template&id=591d8186&scoped=true&"
import script from "./NavSidebar.vue?vue&type=script&lang=js&"
export * from "./NavSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NavSidebar.vue?vue&type=style&index=0&id=591d8186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d8186",
  null
  
)

export default component.exports